import { newsApi } from 'yxt-biz-pc/packages/api';

// 查询资讯列表
export const getNewsList = (data) => {
  return newsApi.get('infos', data);
}
;
